<div class="padding-block" fxLayout="row" fxLayoutAlign="space-between stretch">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" [ngStyle.xs]="{width: '100%'}">
        <div fxLayout="column" fxLayout.xs="row" fxLayoutAlign="space-evenly center" [ngStyle.gt-md]="{ height: '80px', 'margin-right': '16px' }"
             [ngStyle.xs]="{width: '100%', 'padding-bottom': '10px', 'padding-top': '10px'}">
            <app-patient-selector [buttonMode]="true" [control]="patientControl" [ngStyle.gt-xs]="{'padding-bottom': '5px'}" [disabled]="disabled"></app-patient-selector>
            <app-physician-selector [control]="physicianControl" [ngStyle.gt-xs]="{'padding-top': '5px'}"
                [patientClientId]="patient && patient.clientId ? patient.clientId : -1" [disabled]="sameAsPrimary || disabled"></app-physician-selector>
            <app-patient-info-popup *ngIf="isPhone && patient !== undefined && patient !== null" [selectedPatient]="patient"></app-patient-info-popup>
            <div *ngIf="!isPhoneOrTablet" fxLayout="column" fxLayoutAlign="end" style="padding-top: 23px">
                <dx-switch
                    style="width: 40px"
                    [value]="false"
                    [hint]="'Same as Primary Physician'"
                    (valueChange)="sameAsPrimaryPhysician($event)"
                    [disabled]="patient === undefined || patient === null || disabled">
                </dx-switch>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between space-between" [ngStyle.gt-md]="{ 'margin-right': '16px' }" [ngStyle.xs]="{width: '100%'}">
            <address class="details" [ngStyle.xs]="{height: 'auto'}">
                <span class="strong">Client:</span> {{ Client }} <br />
                <span class="strong">Patient:</span> {{ PatientFullName }} {{ DOB }} {{ Gender }}<br />
                <span class="strong">Room:</span> {{ Room }}
                <span class="strong">Unit:</span> {{ Unit }}<br />
                <span class="strong">Ordering Physician:</span> {{ Physician }}<br />
            </address>
            <app-patient-info-popup *ngIf="!isPhone" [selectedPatient]="patient"></app-patient-info-popup>
        </div>
        <div>

        </div>
    </div>
    <div *ngIf="innerSignature">
      <app-signature-viewer [signature]="innerSignature"></app-signature-viewer>
    </div>
</div>
